import qs from 'qs';
import configure, { apiUrls } from '@/constant/configure';
import api from '@/helpers/api_helper';

const baseUrl = apiUrls.matching;

export interface SodomallOrderFlatItem {
    mallOrderId: string;
    mallOrderNumber: string;
    mallOrderGroupId: string;
    mallOrderGroupNumber: string;
    orderedAt: string;
    orderStateCode: number;
    orderState: string;
    ordererInfo: {
        ordererName: string;
        ordererPhoneNumber: string;
    };
    productInfo: {
        representProductName: string;
        productOptionsName: string;
        productAmount: number;
        totalCharge: number;
    };
    receivingDate: string | null;
    pickupDateStart: string | null;
    pickupDateEnd: string | null;
    priceInfo: {
        totalCharge: number;
    };
}

export interface SodomallOrderListFlatResponse {
    items: SodomallOrderFlatItem[];
    total: number;
}

export interface SodomallOrderSearchParams {
    ordererName?: string;
    phoneNumber?: string;
    productName?: string;
    orderStateTypes?: string[];
    startDate?: string;
    endDate?: string;
    offset?: number;
    limit?: number;
}

/**
 * 소도몰 공구주문 현황 조회 (평면 구조)
 * mall_order 기준으로 평면 그리드 데이터를 조회합니다.
 */
export const getSodomallOrderListFlat = async (
    sellerId: string,
    params: SodomallOrderSearchParams,
): Promise<{ list: SodomallOrderFlatItem[]; total: number }> => {
    try {
        const queryParams: Record<string, any> = {
            offset: params.offset || 0,
            limit: params.limit || 15,
        };

        if (params.ordererName) queryParams.ordererName = params.ordererName;
        if (params.phoneNumber) queryParams.phoneNumber = params.phoneNumber;
        if (params.productName) queryParams.productName = params.productName;
        if (params.orderStateTypes && params.orderStateTypes.length > 0) {
            queryParams.orderStateTypes = params.orderStateTypes.join(',');
        }
        if (params.startDate) queryParams.startDate = params.startDate;
        if (params.endDate) queryParams.endDate = params.endDate;

        const queryStr = qs.stringify(queryParams);

        const { data } = await api.get<SodomallOrderListFlatResponse>(
            `/seller/${sellerId}/sodomall/contracts/orders-flat?${queryStr}`,
            {
                baseURL: baseUrl,
            },
        );

        return {
            list: data?.items || [],
            total: data?.total || 0,
        };
    } catch (e: any) {
        throw e;
    }
};
